import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ArrowLeftIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M15.2953 4.70528C15.6846 5.09458 15.6849 5.72568 15.2959 6.11528L9.42006 12L15.2959 17.8847C15.6849 18.2743 15.6846 18.9054 15.2953 19.2947C14.9058 19.6843 14.2743 19.6843 13.8848 19.2947L7.29716 12.7071C6.90664 12.3166 6.90664 11.6834 7.29717 11.2929L13.8848 4.70528C14.2743 4.31577 14.9058 4.31577 15.2953 4.70528Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ArrowLeftIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ArrowLeftIcon;
